import { render } from "./RoleSlider.vue?vue&type=template&id=3a854a5a&scoped=true"
import script from "./RoleSlider.vue?vue&type=script&lang=js"
export * from "./RoleSlider.vue?vue&type=script&lang=js"

import "./RoleSlider.vue?vue&type=style&index=0&id=3a854a5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a854a5a"]])

export default __exports__